import { render, staticRenderFns } from "./ReceiveWarehouse.vue?vue&type=template&id=6c342b6d"
import script from "./ReceiveWarehouse.vue?vue&type=script&lang=js"
export * from "./ReceiveWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports